import { connect } from 'react-redux';
import {
    addFavouriteProjectPriority,
    fetchProjectPrioritys,
    filterProjectPriority,
    getAllProjectPriority,
    getUnselectedAllProjectPriority,
    handleProjectPriorityRequestClose,
    hideProjectPriorityLoader,
    showProjectPriorityLoader,
    onAddProjectPriority,
    onAllProjectPrioritySelect,
    onProjectPriorityClose,
    onProjectPrioritySelect,
    onDeleteProjectPriority,
    onDeleteSelectedProjectPriority,
    onFilterProjectPriorityOptionSelect,
    onSaveProjectPriority,
    onToggleProjectPriorityDrawer,
    updateSearchProjectPriority,
    onUpdateProjectPriorities,
} from 'actions/projectPriority';
import {
    showProjectLoader,
    onSaveProject,
} from 'actions/project';

import Component from './component';


export const mapStateToProps = ({ projects, projectPrioritys, settings }) => {
    const { width } = settings;
    const {
        loader,
        alertMessage,
        showMessage,
        noContentFoundMessage,
        selectedSectionId,
        drawerState,
        projectPriority,
        searchProjectPriority,
        filterOption,
        allProjectPriority,
        projectPriorityList,
        selectedProjectPriority,
        selectedProjectPrioritys,
        addProjectPriorityState,
        updatingGlobalPriorities,
        updatingProjectCostPriorities,
        updatingProjectBusinessPriorities
    } = projectPrioritys;
    const {
        projectList,
    } = projects;
    return {
        width,
        loader,
        alertMessage,
        showMessage,
        noContentFoundMessage,
        selectedSectionId,
        drawerState,
        projectPriority,
        searchProjectPriority,
        filterOption,
        allProjectPriority,
        projectPriorityList,
        selectedProjectPriority,
        selectedProjectPrioritys,
        addProjectPriorityState,
        updatingGlobalPriorities,
        projectList,
        updatingProjectCostPriorities,
        updatingProjectBusinessPriorities
    };
};
export default connect(mapStateToProps, {
    fetchProjectPrioritys,
    addFavouriteProjectPriority,
    onProjectPrioritySelect,
    onAddProjectPriority,
    onProjectPriorityClose,
    onFilterProjectPriorityOptionSelect,
    onSaveProjectPriority,
    onDeleteProjectPriority,
    onDeleteSelectedProjectPriority,
    filterProjectPriority,
    getAllProjectPriority,
    getUnselectedAllProjectPriority,
    onAllProjectPrioritySelect,
    updateSearchProjectPriority,
    onToggleProjectPriorityDrawer,
    handleProjectPriorityRequestClose,
    hideProjectPriorityLoader,
    showProjectPriorityLoader,
    showProjectLoader,
    onSaveProject,
    onUpdateProjectPriorities,
})(Component);


// WEBPACK FOOTER //
// ./components/Agile/projectPriority/container.js